<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
html {
  font-size: 62.5%;
}
body {
  --blue024580: #024580;
  --gary727171: #727171;
  --garyE2: #e2e2e2;
  --garyEF: #efefef;
  --garyD5: #d5d5d5;
  --textBlueColor: #0071ce;
  --textBlueColor-409eff: #409eff;
  --textBlueColor20: #0071ce33;
  --textBlueColor60: #0071ce99;
  --textBlueColor80: #0071ced2;
  --textWhiteColor: #fff;
  --textWhiteColor50: #ffffff99;
  --textWhiteColor40: #ffffff66;
  --textWhiteColor20: #ffffff33;
  --textGaryColor: #d4d4d4;
  --textBlackColor: #3c3c3c;
  --textBlackColor30: #3c3c3c66;
  --BLACK-333: #333;

  --mainBlue: var(--blue024580);
  --mainGary: var(--gary727171);
}
p {
  font-size: 1.7rem;
  font-family: Regular;
}
#app {
  color: var(--mainGary);
  height: 100%;
  width: 100%;
  font-size: 62.5%;
}
@media screen and (max-width: 1800px) {
  html {
    font-size: 55%;
  }
}
@media screen and (max-width: 1700px) {
  html {
    font-size: 52%;
  }
}
@media screen and (max-width: 1600px) {
  html {
    font-size: 49%;
  }
}
@media screen and (max-width: 1500px) {
  html {
    font-size: 45%;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue